import { FileuploadService } from "../services/fileupload.service";
import { CommonService } from "./../services/common.service";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BaseComponent } from "../pages/base.component";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { UntypedFormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { environment } from "../../environments/environment";
import { ChartOptions, ChartType, ChartDataSets } from "chart.js";

@Component({
  selector: "app-main-dashboard",
  templateUrl: "./main-dashboard.component.html",
  styleUrls: ["./main-dashboard.component.css"],
})
export class MainDashboardComponent extends BaseComponent implements OnInit {
  showMonthly: string = "2";
  Inclusivity: any;
  admittedCount: any;
  registeredCount: any;
  appliedCount: any;
  AcceptancePercentage: any;
  referalCount: any;
  aluminiCount: any;
  graduationCount: any;
  shortCoursesCount: any;
  kuccpsCount: any;
  responseData: Array<any> = [];
  headerText: string = "";
  txt: boolean = false;
  Admitted: boolean = false;
  AdminDashboard: any = {};
  studentfeereceivables: any;
  staffAttendancePresent: any;
  staffAttendanceAbsent: any;
  studentAttendancePresent: any;
  studentAttendanceAbsent: any;
  library: any;
  inventory: any;
  feedback: any;
  users: any;
  events: any;
  totalStaff: any;
  totalStudent: any;
  signedUp: any;
  applied: any;
  shortCourses: any;
  admitted: any;
  rejected: any;
  registered: any;
  applicationInPorgrs: any;
  in_review: any;
  not_registered: any;
  kuccps_yes: any;
  kuccps_no: any;
  schl_of_agri: any;
  schl_of_bus_eco: any;
  schl_of_edu: any;
  schl_of_scnc_tech: any;
  Bachelor_of_Agri_Technology_and_Food_Systems: any;
  Bachelor_of_Business_and_Entrepreneurship: any;
  Bachelor_of_Data_Science: any;
  Bachelor_of_Economics_and_Statistics: any;
  Bachelor_of_Science_in_Cybersecurity_and_Digital_Forensics: any;
  Bachelor_of_Technology_Education: any;
  PG_Diploma_in_Leadership_and_Accountability: any;
  PG_Diploma_in_Learning_Design_and_Technology: any;
  enroll: any;
  notEnroll: any;
  sentBack: any;
  Intiated: any;
  news: any;
  SchoolId: any = localStorage.getItem("SchoolId");
  DEPARTMENT_ID: any = localStorage.getItem("DepartmentId");
  @ViewChild("InputFile", { static: false }) fileInput: ElementRef | any;
  refreshed: boolean = false;
  reload: string = "";
  roleId: any = localStorage.getItem("RoleId");
  status: any;
  cId: any;
  kuccpsData: Array<any> = [];
  dashboardData: Array<any> = [];
  courseList: Array<any> = [];
  allProgramees: Array<any> = [];
  allSchools: any[] = []; // complete list of schools + counts
  top10Schools: any[] = []; // first 10
  otherSchools: any[] = []; // remaining
  // For older Chart.js versions (v2)
  public pieChartOptions = {
    responsive: true,
    legend: {
      position: "right",
      labels: {
        usePointStyle: true, // Use the point style instead of a box
        pointStyle: "circle", // Set the point style to a circle
        // You can also adjust the size of the circles
        // boxWidth: 10,
      },
    },
  };
  public pieChartLabels: string[] = ["KUCCPS", "PSSP"];
  public pieChartData: number[] = [];
  public pieChartColors = [
    {
      backgroundColor: ["#fed8ca", "#80bcc7"],
    },
  ];
  public pieChartType: any = "pie"; // Chart type
  public pieChartColorsforGender = [
    {
      backgroundColor: ["#f2e1fd", "#bee3fe"],
    },
  ];

  public pieChartOptionsforGender = {
    responsive: true,
    legend: {
      position: "right",
      labels: {
        usePointStyle: true, // Use the point style instead of a box
        pointStyle: "circle", // Set the point style to a circle
        // You can also adjust the size of the circles
        // boxWidth: 10,
      },
    },
  };
  public pieChartLabelsforGender: string[] = ["Female", "Male"];
  public pieChartDataforGender: number[] = [];

  public barChartType: any = "bar";
  public barChartOptions: any = {
    responsive: true,
    legend: {
      display: true,
      position: "bottom", // 👈 Move legend below chart
    },
    scales: {
      xAxes: [{ gridLines: { display: false } }],
      yAxes: [
        {
          gridLines: { display: true },
          ticks: {
            beginAtZero: true,
            max: 100,
            stepSize: 20, // Show ticks every 20
            callback: function (value: number) {
              return value + "%"; // Show values as percentages
            },
          },
        },
      ],
    },
  };

  public barChartData: any[] = [];
  public barChartLabels: string[] = [];
  // bar chart for programme
  public barChartDataforProgramme: any[] = [];
  public barChartLabelsforProgramme: string[] = [];
  public barChartOptionsforProgramme: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: "end", // position on top
        align: "end", // align above the bar
        color: "#000", // text color
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value: number) => value, // show raw value
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  //barChart for Local students
  localCounties: Array<any> = [];
  public barChartDataforLocalStudents: any[] = [];
  public barChartLabelsforLocalStudents: string[] = [];
  public barChartOptionsforLocalStudents: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: "end", // position on top
        align: "end", // align above the bar
        color: "#000", // text color
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value: number) => value, // show raw value
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  //barChart for International students
  internationalCountry: Array<any> = [];
  public barChartDataforInternationalStudents: any[] = [];
  public barChartLabelsforInternationalStudents: string[] = [];
  public barChartOptionsforInternationalStudents: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: "end", // position on top
        align: "end", // align above the bar
        color: "#000", // text color
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value: number) => value, // show raw value
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  //line chart
  public lineChartData: ChartDataSets[] = [];
  public lineChartLabels: string[] = [];
  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false, // allows height to grow dynamically\
    legend: { display: true, position: "top" }, // <-- works in v2
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  public lineChartLegend = false;
  public lineChartType: ChartType = "line";
  studentsStatusForLocalOrInternational: number = 1; // default Local
  dashboardCounts: any = {};
  schoolsCounts: Array<any> = [];
  graduatedProgrames: Array<any> = [];
  shortCoursesData: Array<any> = [];
  programmes: Array<any> = [];
  cohortsData: Array<any> = [];
  statusforSchools: any;
  programmeStatus: any;
  selectedStatus: any;
  selectedTxt: any;
  selectedCId: any;
  constructor(
    CommonService: CommonService,
    toastr: ToastrService,
    private active: ActivatedRoute,
    private FileuploadService: FileuploadService,
    private route: Router,
  ) {
    super(CommonService, toastr);
  }
  async ngOnInit() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      this.roleId,
      this.CommonService.key,
    );
    // let roleID = decryptedValue;
    this.roleId = decryptedValue;
    this.active.queryParams.subscribe((res: any) => {
      this.reload = res.req;
      this.refresh(this.reload);
    });
    this.getDashboardData();
    this.loadAdminDashboard();
    this.getBargraphCounts(2);
    this.getLineChartGraphCounts(2);
    this.getBarChartData(2);
    this.getStatusForLocalOrInternational(
      this.studentsStatusForLocalOrInternational,
    );
    this.getActiveTotalCountDashboard();
    this.getGraduatedCourses();
    this.loadReportDtOptions();
  }
  refresh(val: string) {
    if (!sessionStorage.getItem("refreshedRole")) {
      sessionStorage.setItem("refreshedRole", val);
      if (sessionStorage.getItem("refreshedRole") == val)
        window.location.reload();
    } else {
      // Optionally, clear the session storage key after reloading to allow future reloads
      sessionStorage.removeItem("refreshedRole");
    }
  }
  getDashboardData() {
    this.CommonService.postCall("Dashboard/GetAdminDeanDashboardCount", {
      TNT_CODE: this.TenantCode,
      COURSE_CATEGORY_ID:
        this.roleId == "1" || this.roleId == "2" ? 0 : this.SchoolId,
      DEPARTMENT_ID:
        this.roleId == "1" || this.roleId == "2" ? 0 : this.DEPARTMENT_ID,
    }).subscribe((res: any) => {
      this.dashboardData = res;
      this.Inclusivity = res.find(
        (e: any) => e.APPLICATIONSTATUS == "DisabilityYouth",
      );
      this.admittedCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "Admitted",
      );
      this.registeredCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "Registered",
      );
      this.appliedCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "Applied",
      );
      this.kuccpsCount = res.find((e: any) => e.APPLICATIONSTATUS == "Kuccps");
      this.aluminiCount = res.find((e: any) => e.APPLICATIONSTATUS == "alumni");
      this.graduationCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "graduation",
      );
      this.shortCoursesCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "shortcourses",
      );
      this.pieChartData = [
        this.kuccpsCount.COUNT1,
        this.kuccpsCount.REVIEWCOUNT,
      ];
      this.AcceptancePercentage = res.find(
        (e: any) => e.APPLICATIONSTATUS == "AcceptancePercentage",
      );
      this.referalCount = res.find(
        (e: any) => e.APPLICATIONSTATUS == "OukReferral",
      );
    });
  }
  registrationDetails(status: number, txt: string, cId: any) {
    this.crntPage = 1; // ✅ IMPORTANT (first time reset)

    this.selectedStatus = status;
    this.selectedTxt = txt;
    this.selectedCId = cId;

    this.loadRegistrationData();
  }
  loadRegistrationData() {
    this.activeSpinner();

    this.headerText = this.selectedTxt;

    let headers = [
      "Registered",
      "Initiated",
      "In Review",
      "Admitted",
      "Accepted",
      "Alumni",
      "Graduated",
      "Short Courses",
    ];

    this.txt = headers.includes(this.selectedTxt);
    this.Admitted = this.selectedTxt.includes("Admitted");

    this.responseData = [];

    let payload = {
      TNT_CODE: localStorage.getItem("TenantCode"),
      STATUS: this.selectedStatus,
      CID: this.selectedCId,
      SchoolId: this.SchoolId,
      DepartmentId: this.DEPARTMENT_ID,

      // PAGINATION
      Limit: this.pgSze,
      Offset: this.crntPage - 1,

      Search: this.srchFltr,
    };

    this.CommonService.postCall(
      "Registration/Loadregistrationbreakupdetails",
      payload,
    ).subscribe(
      (res: any) => {
        this.responseData = res?.data?.data;

        // optional (if API supports)
        this.ttlItms = res?.data?.total_records ?? this.responseData.length;
        this.pageEntry = this.GetPageSizeTxt(this.crntPage, this.ttlItms);

        this.deactivateSpinner();
      },
      () => {
        this.deactivateSpinner();
      },
    );
  }
  setPage(pagNo: number): void {
    ((this.crntPage = pagNo), this.loadRegistrationData());
  }
  search(val: any) {
    this.crntPage = 1;
    this.srchFltr = val;
    if (val.length > 2 || val.length == 0) {
      this.loadRegistrationData();
    }
  }
  loadAdminDashboard() {
    this.AdminDashboard = {};
    this.CommonService.getCall(
      `Dashboard/LoadAdminOrSuperadminDashboard/${localStorage.getItem(
        "RoleId",
      )}/${localStorage.getItem("TenantCode")}`,
    ).subscribe((res: any) => {
      this.AdminDashboard = res;
      this.studentfeereceivables = res["studentfeereceivables"];
      this.staffAttendancePresent = res["staffattendance"][0];
      this.staffAttendanceAbsent = res["staffattendance"][2];
      this.studentAttendancePresent = res["studentattendance"][0];
      this.studentAttendanceAbsent = res["studentattendance"][1];
      this.library = res["library"];
      this.inventory = res["inventory"];
      this.feedback = res["feedback"];
      this.users = res["users1"];
      this.events = res["Event"];
      this.courses = res["Courese"];
      this.totalStaff = res["Totalstaff"];
      this.totalStudent = res["TotalStudents"];
      this.signedUp = res["SignedUp"];
      this.applied = res["Applied"];
      this.shortCourses = res["shortcourses"];
      this.admitted = res["Admitted"];
      this.rejected = res["Rejected"];
      this.registered = res["Registered"];
      this.applicationInPorgrs = res["Application_in_Progress"];
      this.in_review = res["In_Review"];
      this.not_registered = res["Not_Registered"];
      this.kuccps_yes = res["Kuccps_Yes"];
      this.kuccps_no = res["Kuccps_No"];
      // this.schl_of_agri = res["School_of_Agriculture"];
      // this.schl_of_bus_eco = res["School_of_Business_and_Economics"];
      // this.schl_of_edu = res["School_of_Education"];
      // this.schl_of_scnc_tech = res["School_of_Science_and_Technology"];

      // this.Bachelor_of_Agri_Technology_and_Food_Systems =
      //   res["Bachelor_of_Agri_Technology_and_Food_Systems"];
      // this.Bachelor_of_Business_and_Entrepreneurship =
      //   res["Bachelor_of_Business_and_Entrepreneurship"];
      // this.Bachelor_of_Data_Science = res["Bachelor_of_Data_Science"];
      // this.Bachelor_of_Economics_and_Statistics =
      //   res["Bachelor_of_Economics_and_Statistics"];
      // this.Bachelor_of_Science_in_Cybersecurity_and_Digital_Forensics =
      //   res["Bachelor_of_Science_in_Cybersecurity_and_Digital_Forensics"];
      // this.Bachelor_of_Technology_Education =
      //   res["Bachelor_of_Technology_Education"];
      // this.PG_Diploma_in_Leadership_and_Accountability =
      //   res["PG_Diploma_in_Leadership_and_Accountability"];
      // this.PG_Diploma_in_Learning_Design_and_Technology =
      //   res["PG_Diploma_in_Learning_Design_and_Technology"];
      this.enroll = res["Enroll"];
      this.notEnroll = res["Not_Enrolled"];
      this.sentBack = res["Sentback"];
      this.Intiated = res["Initiate"];
    });
  }
  getBargraphCounts(status: any) {
    this.statusforSchools = status;
    this.CommonService.postCall("Dashboard/GetAdminDeanDashboardGraphList", {
      TNT_CODE: this.TenantCode,
      Decrypt_Role: localStorage.getItem("RoleId"),
      USER_ID: this.userId,
      ApplicationGraphStatus: status,
    }).subscribe((res: any) => {
      const admitted = res?.data?.Admittedcount || [];
      const registered = res?.data?.Registeredcount || [];
      const pending = res?.data?.PendingApplicationcount || [];

      // Calculate totals for each school (row-wise sum)
      const totals = admitted.map(
        (_: any, i: any) =>
          (admitted[i] || 0) + (registered[i] || 0) + (pending[i] || 0),
      );

      // Convert counts to percentages and round off
      const admittedPercent = admitted.map((val: any, i: any) =>
        totals[i] ? Number(((val / totals[i]) * 100).toFixed(2)) : 0,
      );

      const registeredPercent = registered.map((val: any, i: any) =>
        totals[i] ? Number(((val / totals[i]) * 100).toFixed(2)) : 0,
      );

      const pendingPercent = pending.map((val: any, i: any) =>
        totals[i] ? Number(((val / totals[i]) * 100).toFixed(2)) : 0,
      );

      // Bind percentage data to chart
      this.barChartData = [
        {
          data: admittedPercent,
          label: "Admitted",
          backgroundColor: "#FF7043",
        },
        {
          data: registeredPercent,
          label: "Registered",
          backgroundColor: "#00796B",
        },
        {
          data: pendingPercent,
          label: "Pending Application",
          backgroundColor: "#BDBDBD",
        },
      ];

      this.barChartLabels = res?.schoolnames;
    });
  }
  getLineChartGraphCounts(status: any) {
    this.activeSpinner();
    this.CommonService.postCall(
      "Dashboard/GetDashboardApplicationsGraphCount",
      {
        TNT_CODE: this.TenantCode,
        ApplicationGraphStatus: status,
        COURSE_CATEGORY_ID: this.SchoolId,
        DEPARTMENT_ID: this.DEPARTMENT_ID,
      },
    ).subscribe(
      (res: any) => {
        // Trim values and convert to correct types
        this.lineChartLabels = res.LabelKey.map((label: string) =>
          label.trim(),
        );

        this.lineChartData = [
          {
            data: res.data.map((val: string) => Number(val.trim())),
            label: "Applications",
            fill: true,
            borderColor: "#007b8f",
            backgroundColor: "rgba(0,123,143,0.2)",
            lineTension: 0.4,
            pointBackgroundColor: "#fff",
            pointBorderColor: "#007b8f",
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ];

        this.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.deactivateSpinner();
      },
    );
  }

  getBarChartData(status: any) {
    this.programmeStatus = status;
    this.activeSpinner();
    this.CommonService.postCall(
      "Dashboard/GetDashboardCoursePopularityGraphCount",
      {
        TNT_CODE: this.TenantCode,
        ApplicationGraphStatus: status,
        COURSE_CATEGORY_ID: this.SchoolId,
        DEPARTMENT_ID: this.DEPARTMENT_ID,
      },
    ).subscribe(
      (res: any) => {
        // Example response: { LabelKey: ["ED01","BE02","IT03"], data: [410, 350, 362] }

        this.barChartLabelsforProgramme = res.LabelKey;
        this.barChartDataforProgramme = [
          {
            data: res.data.map((val: string) => Number(val)),
            label: "Programmes",
            backgroundColor: "#007b8f",
            hoverBackgroundColor: "#007b8f", // same as normal
            borderColor: "#007b8f",
            hoverBorderColor: "#007b8f",
          },
        ];
        this.allProgramees = res?.GetAll;
        this.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.deactivateSpinner();
      },
    );
  }
  getBarChartDataForLocalStudents(status: any) {
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetLocalStudentsGraphCount", {
      TNT_CODE: this.TenantCode,
      ApplicationGraphStatus: status,
      COURSE_CATEGORY_ID: this.SchoolId,
      DEPARTMENT_ID: this.DEPARTMENT_ID,
    }).subscribe(
      (res: any) => {
        // Example response: { LabelKey: ["ED01","BE02","IT03"], data: [410, 350, 362] }

        this.barChartLabelsforLocalStudents = res.LabelKey;
        this.barChartDataforLocalStudents = [
          {
            data: res.data.map((val: string) => Number(val)),
            label: "county",
            backgroundColor: "#007b8f",
            hoverBackgroundColor: "#007b8f", // same as normal
            borderColor: "#007b8f",
            hoverBorderColor: "#007b8f",
          },
        ];
        this.localCounties = res?.GetAll;
        this.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.deactivateSpinner();
      },
    );
  }
  getBarChartDataForInternationalStudents(status: any) {
    this.activeSpinner();
    this.CommonService.postCall(
      "Dashboard/GetInternationalStudentsGraphCount",
      {
        TNT_CODE: this.TenantCode,
        ApplicationGraphStatus: status,
        COURSE_CATEGORY_ID: this.SchoolId,
        DEPARTMENT_ID: this.DEPARTMENT_ID,
      },
    ).subscribe(
      (res: any) => {
        // Example response: { LabelKey: ["ED01","BE02","IT03"], data: [410, 350, 362] }

        this.barChartLabelsforInternationalStudents = res.LabelKey;
        this.barChartDataforInternationalStudents = [
          {
            data: res.data.map((val: string) => Number(val)),
            label: "Country",
            backgroundColor: "#007b8f",
            hoverBackgroundColor: "#007b8f", // same as normal
            borderColor: "#007b8f",
            hoverBorderColor: "#007b8f",
          },
        ];
        this.internationalCountry = res?.GetAll;
        this.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.deactivateSpinner();
      },
    );
  }
  getStatusForLocalOrInternational(type: number) {
    this.studentsStatusForLocalOrInternational = type;
    if (type === 1) {
      this.getBarChartDataForLocalStudents(2); // or default value
    } else {
      this.getBarChartDataForInternationalStudents(2);
    }
  }
  getActiveTotalCountDashboard() {
    this.CommonService.postCall("Dashboard/GetActiveTotalCountDashboard", {
      TNT_CODE: this.TenantCode,
      COURSE_CATEGORY_ID: this.SchoolId,
      DEPARTMENT_ID: this.DEPARTMENT_ID,
    }).subscribe((res: any) => {
      this.dashboardCounts = res?.ActiveTotalCounts;
      this.pieChartDataforGender = [
        this.dashboardCounts[4].ACTIVECOUNT,
        this.dashboardCounts[4].TOTALCOUNT,
      ];
      this.schoolsCounts = res?.GetAll;
    });
  }
  getGraduatedCourses() {
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetGraduatedCourses", {
      TNT_CODE: this.TenantCode,
      COURSE_CATEGORY_ID: this.SchoolId,
      DEPARTMENT_ID: this.DEPARTMENT_ID,
    }).subscribe((res: any) => {
      this.graduatedProgrames = res;
      this.deactivateSpinner();
    });
  }
  loadReportDtOptions() {
    this.dtOptions = {
      dom: "Bfrtip",
      buttons: [
        {
          extend: "excel",
          filename: "Report",
        },
        {
          extend: "pdfHtml5",
          filename: "Report",
          title: "Report",
          orientation: "landscape",
          pageSize: "LEGAL",
          text: "PDF",
          exportOptions: {
            columns: ":visible", // Ensures all visible columns are exported
          },
        },
      ],
      order: [],
    };
  }
  closeModal() {
    this.srchFltr = "";
    this.responseData = [];
  }
  downloadPDF(type: string) {
    let payload = {
      TNT_CODE: this.TenantCode,
      STATUS: this.selectedStatus,
      STATUS_NAME: this.headerText,
      CID: this.selectedCId,
      SchoolId: localStorage.getItem("SchoolId"),
      DepartmentId: localStorage.getItem("DepartmentId"),
      file_name: "SummaryReport.jrxml",
      file_type: type,
      token: localStorage.getItem("tkn"),
    };
    this.activeSpinner();
    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        const urlSegments = res?.data?.viewPath.split("/");
        const fileName = urlSegments[urlSegments.length - 1];
        const a = document.createElement("a");
        a.href = environment.downloadReportUrl + fileName;
        // a.download = "Application Form.pdf"; // Specify the desired file name
        a.style.display = "none"; // Hide the anchor element
        document.body.appendChild(a); // Append to the DOM
        a.click(); // Trigger the download
        document.body.removeChild(a);
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
  }
  downloadSchoolPDF(type: string) {
    let payload = {
      TNT_CODE: this.TenantCode,
      Decrypt_Role: this.roleId,
      USER_ID: this.userId,
      ApplicationGraphStatus: this.statusforSchools,
      file_name: "SchoolAndDepartment.jrxml",
      file_type: type,
      token: localStorage.getItem("tkn"),
    };
    this.activeSpinner();
    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        const urlSegments = res.data.viewPath.split("/");
        const fileName = urlSegments[urlSegments.length - 1];
        const a = document.createElement("a");
        a.href = environment.downloadReportUrl + fileName;
        // a.download = "Application Form.pdf"; // Specify the desired file name
        a.style.display = "none"; // Hide the anchor element
        document.body.appendChild(a); // Append to the DOM
        a.click(); // Trigger the download
        document.body.removeChild(a);
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
  }
  downloadProgrammePDF(type: string) {
    let payload = {
      TNT_CODE: this.TenantCode,
      ApplicationGraphStatus: this.programmeStatus,
      COURSE_CATEGORY_ID: this.SchoolId,
      DEPARTMENT_ID: this.DEPARTMENT_ID,
      file_name: "Programmes.jrxml",
      file_type: type,
      token: localStorage.getItem("tkn"),
    };
    this.activeSpinner();
    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        const urlSegments = res.data.viewPath.split("/");
        const fileName = urlSegments[urlSegments.length - 1];
        const a = document.createElement("a");
        a.href = environment.downloadReportUrl + fileName;
        // a.download = "Application Form.pdf"; // Specify the desired file name
        a.style.display = "none"; // Hide the anchor element
        document.body.appendChild(a); // Append to the DOM
        a.click(); // Trigger the download
        document.body.removeChild(a);
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
  }
  getShortCourses() {
    this.shortCoursesData = [];
    this.activeSpinner();
    let payLoad = {
      TNT_CODE: this.TenantCode,
      DEPARTMENT_ID: localStorage.getItem("DepartmentId"),
      COURSE_CATEGORY_ID: localStorage.getItem("SchoolId"),
    };
    this.CommonService.postCall("ShortCourse/GetList", payLoad).subscribe(
      (res: any) => {
        this.shortCoursesData = res.filter(
          (e: any) => e.COURSE_STATUS === true,
        );
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  loadCourse() {
    this.activeSpinner();
    let payLoad = {
      TENANT_CODE: this.tId || this.TenantCode,
      ROLE_NAME: localStorage.getItem("RoleName"),
      USER_ID: localStorage.getItem("UserId"),
    };
    this.CommonService.postCall("LoadCourse", payLoad).subscribe(
      (res: any) => {
        this.programmes = [];
        this.programmes = res.filter(
          (e: any) => e.STATUS_DESCRIPTION === "Active",
        );
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getCohortList() {
    this.cohortsData = [];
    this.activeSpinner();
    this.CommonService.postCall("CohortManagement/GetList", {
      TNT_CODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        this.cohortsData = res.filter((e: any) => e.STATUS === "Active");
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
  }
}
